import { http } from '../../../../api/http';

export interface DisponibilidadBancariaItem {
  idCajaBanco: number;
  codigo: string;
  nombre: string;
  tipoCajaBanco: string;
  ingresosSoles: number;
  egresosSoles: number;
  saldoSoles: number;
  ingresosDolares: number;
  egresosDolares: number;
  saldoDolares: number;
}

export interface DisponibilidadBancariaTotales {
  totalIngresosSoles: number;
  totalEgresosSoles: number;
  totalSaldoSoles: number;
  totalIngresosDolares: number;
  totalEgresosDolares: number;
  totalSaldoDolares: number;
}

export interface DisponibilidadBancariaResponse {
  items: DisponibilidadBancariaItem[];
  totales: DisponibilidadBancariaTotales | null;
}

const ENDPOINT = '/tesoreria/disponibilidad';

export class DisponibilidadBancariaService {
  public static async getDisponibilidad(periodoInicio: string, periodoFin: string, ejercicio: string): Promise<DisponibilidadBancariaResponse> {
    const response = await http.get(`${ENDPOINT}?periodoInicio=${periodoInicio}&periodoFin=${periodoFin}&ejercicio=${ejercicio}`);
    return response.data;
  }
}
